export const BAR_OFFSET_RIGHT_PX = 16;
// Bar container — matches Figma: 26px tall pills + 2px breathing top/bottom.
export const BAR_HEIGHT_PX = 36;
// Tabs + entry pill + history button — matches Figma frame 49:36479.
export const BAR_BUTTON_HEIGHT_PX = 26;
// Gap between adjacent bar controls — Figma uses 6px.
export const BAR_CONTROL_GAP_PX = 6;

export const MAX_OPEN_TABS = 5;

export const STORAGE_KEY = 'agentforge:bar:v1';
